export default {
    label: 'Vysvětlivky',
    clientService: 'Klientem preferovaný',
    slotService: 'Objednání online',
    normalService: 'Servis'
}
